import AppRoutes from './AppRoutes';
import EnvironmentLabel from './components/EnvironmentLabel/EnvironmentLabel';
import ImpersonationLabel from './components/ImpersonationLabel/ImpersonationLabel';
import './styles/custom.scss';
import { storeFirstTouchUtm } from './utilities/utm';
import { useEffect } from 'react';

const App: React.FC = () => {
  useEffect(() => {
    storeFirstTouchUtm();
  }, []);

  return (
    <>
      <ImpersonationLabel />

      <EnvironmentLabel />

      <AppRoutes />
    </>
  );
};

export default App;
